@use '../../scss/utility/functions' as utility;
@use './bar-loader-vars';

:host {
  @include bar-loader-vars.wb-bar-loader-vars;
  display: block;
  color: var(--bar-loader-text-color);
}

.inner {
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-column-gap: var(--bar-loader-content-side-gap);
  grid-row-gap: var(--bar-loader-content-top-gap);
  grid-template-rows: auto min-content;
  width: 100%;
}

.label {
  white-space: nowrap;
}

.percentage {
  grid-column-start: 2;
}

.wb-progress {
  grid-column: 1 / span 2;
  grid-row-start: 2;
  overflow: hidden;
}

.has-no-text {
  grid-template-rows: min-content;
}

:host([side-label]) .inner {
  grid-template-columns: minmax(1%, min-content) minmax(50%, 1fr) auto;
  grid-template-rows: min-content;

  .wb-progress {
    grid-column: 2 / span 1;
    grid-row-start: 1;
    margin-block-start: utility.wb-pixel-to-rem(10px);
  }

  .percentage {
    grid-column-start: 3;
  }
}

:host([side-label][hide-percentage]),
:host([side-label][value='indeterminate']) {
  .inner {
    grid-template-columns: minmax(1%, min-content) minmax(50%, 1fr);
  }
}
